import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { useEffect, createElement, useState, useMemo } from 'react';
import { ToggleButtonGroup, ToggleButton, Autocomplete as Autocomplete$1, TextField as TextField$1, CircularProgress, Button as Button$1, FormControlLabel as FormControlLabel$1, Checkbox as Checkbox$1, Tooltip as Tooltip$1, Box, Grid, InputAdornment, IconButton, Collapse, Skeleton, Paper, Typography as Typography$1, createSvgIcon, Link } from '@mui/material';
import { tocCharsWithNoOptions, tocCountForChar, tocDoOptionsExistForChar, tocFirstOption, tocPageForChar } from '@elevate-ui/services';
import Typography from '@mui/material/Typography';
import { useTheme, createTheme } from '@mui/material/styles';
import debounce from 'lodash.debounce';
import { red } from '@mui/material/colors';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { useHistory } from 'react-router-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var baseOptions = '0ABCDEFGHIJKLMNOPQRSTUVWXYZ';
var options = baseOptions.split('');
var AlphaSelector = function (_a) {
    var selectedOptions = _a.selectedOptions, disabled = _a.disabled, onChange = _a.onChange, _b = _a.isExclusive, isExclusive = _b === void 0 ? false : _b, label = _a.label, toc = _a.toc;
    var _c = React.useState([]), selected = _c[0], setSelected = _c[1];
    var _d = React.useState([]), noOptions = _d[0], setNoOptions = _d[1];
    var handleToggle = function (currentlySelected) {
        setSelected(currentlySelected);
        onChange(currentlySelected);
    };
    useEffect(function () {
        if (toc) {
            setNoOptions(tocCharsWithNoOptions(toc));
        }
    }, [toc]);
    useEffect(function () {
        if (selectedOptions) {
            setSelected(selectedOptions);
        }
    }, [selectedOptions]);
    return (jsx(ToggleButtonGroup, __assign({ "aria-label": label, value: selected, exclusive: isExclusive, onChange: function (_event, selected) { return handleToggle(selected); } }, { children: options.map(function (option) { return (jsx(ToggleButton, __assign({ value: option, "aria-label": option, disabled: (noOptions === null || noOptions === void 0 ? void 0 : noOptions.includes(option)) || disabled, sx: { width: '1.5rem', height: '1.5rem' } }, { children: option }), option)); }) })));
};

var AppLoader = function (props) {
    var theme = useTheme();
    return (jsxs("div", __assign({ className: "app-loader-root" }, { children: [jsx(Typography, __assign({ variant: "h2", color: "primary" }, { children: props.title || 'Please Wait' })), jsxs("div", __assign({ className: "app-loader-body" }, { children: [jsx("div", __assign({ className: "spinner-wrapper" }, { children: jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "66.125", height: "64", viewBox: "0 0 66.125 64" }, { children: jsx("path", { d: "M69.656,35.473A33.764,33.764,0,0,0,59.284,11.72a33.519,33.519,0,0,0-11-7.042,33.147,33.147,0,0,0-25.309.493A32.614,32.614,0,0,0,5.722,23.124a32.081,32.081,0,0,0,.492,24.492A31.547,31.547,0,0,0,23.591,64.3a31.014,31.014,0,0,0,23.676-.492A30.48,30.48,0,0,0,63.371,47a29.789,29.789,0,0,0,1.769-6.918c.083,0,.166.008.251.008a4.266,4.266,0,0,0,4.266-4.266c0-.12-.006-.238-.016-.355h.016ZM62.878,46.8A29.414,29.414,0,0,1,46.654,62.328a28.882,28.882,0,0,1-22.042-.493A28.347,28.347,0,0,1,9.662,46.187a27.814,27.814,0,0,1,.493-21.225A27.388,27.388,0,0,1,16.3,16.244a27.112,27.112,0,0,1,8.923-5.656A26.732,26.732,0,0,1,35.531,8.813,26.3,26.3,0,0,1,54.006,17a26.045,26.045,0,0,1,5.425,8.577,25.666,25.666,0,0,1,1.695,9.9h.016q-.015.177-.016.355a4.266,4.266,0,0,0,3.8,4.241A29.415,29.415,0,0,1,62.878,46.8Z", transform: "translate(-3.531 -2.407)", fill: theme.palette.primary.main }) })) })), jsx(Typography, __assign({ variant: "body1" }, { children: props.message }))] }))] })));
};

/**
 * Given an array of autocomplete options, this function will map each option to
 * a new type of GroupedAutocompleteOption which includes the first letter/digit
 *
 * @param {AutocompleteOption[]} options - the initial set of options for the autocomplete control
 * @returns {GroupedAutocompleteOption[]} - transformed options
 */
var groupByLetter = function (options) {
    return options.map(function (option) {
        var firstLetter = option.value[0].toUpperCase();
        return __assign({ firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter }, option);
    });
};
/**
 * Given a possibly null GroupedAutocompleteOption, either transform into an AutocompleteOption
 * or return the null value
 * @param {GroupedAutocompleteOption} option - the selected option
 * @returns {AutocompleteOption} the selected autocomplete option
 */
var processSelectedOption = function (option) {
    if (option) {
        option.firstLetter; var trimmedOption = __rest(option, ["firstLetter"]);
        return trimmedOption;
    }
    else {
        return option;
    }
};
var Autocomplete = function (props) {
    var groupedOptions = [];
    if (props.options && props.options.length) {
        groupedOptions = groupByLetter(props.options);
    }
    var debouncedFilter = props.onFilter ? debounce(props.onFilter, 500) : null;
    return (jsx(Autocomplete$1, { "data-test-id": "autocomplete", id: props.id, isOptionEqualToValue: function (option, selected) {
            return option.optionId === selected.optionId;
        }, options: groupedOptions.sort(function (a, b) { return -b.firstLetter.localeCompare(a.firstLetter); }), groupBy: function (groupedOption) { return groupedOption.firstLetter; }, getOptionLabel: function (groupedOption) { return groupedOption.value; }, loading: props.loading, loadingText: props.loadingText, fullWidth: props.fullWidth, sx: props.fullWidth ? {} : { width: props.width ? props.width : 500 }, size: "small", disablePortal: true, noOptionsText: props.noOptionsText ? props.noOptionsText : 'No Results Found', disabled: props.disabled || !!props.errorText, renderOption: function (props, option) {
            return (createElement("li", __assign({}, props, { key: option.optionId }), option.value));
        }, renderInput: function (params) { return (jsx(TextField$1, __assign({}, params, { "data-testid": "autocomplete", error: !!props.errorText, placeholder: props.errorText || props.label, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (jsxs(React.Fragment, { children: [props.loading ? jsx(CircularProgress, { color: "inherit", size: 20 }) : null, params.InputProps.endAdornment] })) }) }))); }, onChange: function (_event, selectedGroupedOption) {
            props.onChange(processSelectedOption(selectedGroupedOption));
        }, onInputChange: function (_event, newInputValue) {
            if (debouncedFilter) {
                debouncedFilter(newInputValue);
            }
        }, ListboxProps: {
            onScroll: function (event) {
                var listboxNode = event.currentTarget;
                if (listboxNode.scrollTop + listboxNode.clientHeight === listboxNode.scrollHeight) {
                    if (props.loadMore) {
                        props.loadMore();
                    }
                }
            },
        } }));
};

var Button = function (props) { return jsx(Button$1, __assign({}, props)); };

var FormControlLabel = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'standard' : _b, rest = __rest(_a, ["variant"]);
    if (variant === 'outlined') {
        return (jsx(FormControlLabel$1, __assign({ sx: [
                {
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: 'grey.300',
                    borderRadius: 1.5,
                    color: 'primary.main',
                    paddingRight: 1.5,
                    marginLeft: 0,
                    marginRight: 0,
                    width: '100%',
                    boxSizing: 'border-box',
                },
                function (theme) { return ({
                    '&:not(.Mui-disabled)': {
                        '&:hover': {
                            borderColor: theme.palette.primary.main,
                            '& .checkbox-box-icon': {
                                fill: theme.palette.primary.main,
                            },
                        },
                    },
                }); },
                function (theme) { return ({
                    '&.Mui-disabled': {
                        backgroundColor: theme.palette.grey[100],
                    },
                }); },
                {
                    '& .MuiFormControlLabel-label': {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    },
                },
            ] }, rest)));
    }
    return jsx(FormControlLabel$1, __assign({}, rest));
};

var Checkbox = function (_a) {
    var formControlLabelProps = _a.formControlLabelProps, label = _a.label, _b = _a.variant, variant = _b === void 0 ? 'standard' : _b, checkboxProps = __rest(_a, ["formControlLabelProps", "label", "variant"]);
    if (label) {
        var withLabel = (jsx(FormControlLabel, __assign({ variant: "outlined", control: jsx(Checkbox$1, __assign({}, checkboxProps)), disabled: checkboxProps.disabled, label: label }, formControlLabelProps)));
        return variant === 'tooltip' ? (jsx(Tooltip$1, __assign({ title: label }, { children: jsx(Box, { children: withLabel }) }))) : (withLabel);
    }
    return jsx(Checkbox$1, __assign({}, checkboxProps));
};

var TextField = function (props) { return jsx(TextField$1, __assign({}, props)); };

var Tooltip = function (props) { return jsx(Tooltip$1, __assign({}, props)); };

var MuiAutocomplete = {
    styleOverrides: {
        listbox: function (_a) {
            var theme = _a.theme;
            return ({
                '.MuiAutocomplete-groupLabel': {
                    background: theme.palette.grey[100],
                    borderTop: '1px solid',
                    borderColor: theme.palette.grey[300],
                    padding: '0 0.5rem',
                    fontWeight: '700',
                },
                '.MuiAutocomplete-option': {
                    borderTop: '1px solid',
                    borderColor: theme.palette.grey[300],
                    padding: '0.5rem',
                },
            });
        },
    },
};

var MuiButton$1 = {
    defaultProps: {
        disableElevation: true,
    },
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                padding: '0.375rem 1.5rem',
                borderRadius: '0.375rem',
                fontSize: '1rem',
                textTransform: 'none',
                fontWeight: 'normal',
                '&.Mui-disabled': {
                    borderColor: theme.palette.grey[300],
                    backgroundColor: theme.palette.grey[100],
                },
                /**
                 * When an `href` is provided, an anchor element is rendered.
                 * Replicate default button text alignment when rendered as anchor element.
                 */
                '&[href]': {
                    textAlign: 'center',
                },
                '&.Mui-focusVisible': {
                    /**
                     * Set outline-offset to 1px to match the default outline-offset of anchor elements.
                     * Provides visual separation from the button element and the focus indicator.
                     */
                    outlineOffset: '1px',
                },
            });
        },
        contained: function (_a) {
            var theme = _a.theme;
            return ({
                borderWidth: 1,
                borderStyle: 'solid',
                '&:not(.Mui-disabled)': {
                    borderColor: theme.palette.primary.main,
                },
            });
        },
        outlined: function (_a) {
            var theme = _a.theme;
            return ({
                borderColor: theme.palette.grey[300],
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            });
        },
    },
};

var MuiButtonBase = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            '&:focus-visible': {
                outline: "2px solid black",
            },
        },
    },
};

var MuiCheckbox = {
    defaultProps: {
        icon: (jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 6.35 6.35", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { className: "checkbox-box-icon", d: "M15.875 0C7.126 0 0 7.126 0 15.875v31.75C0 56.374 7.126 63.5 15.875 63.5h31.75c8.749 0 15.875-7.126 15.875-15.875v-31.75C63.5 7.126 56.374 0 47.625 0Zm0 5.291h31.75c5.909 0 10.584 4.675 10.584 10.584v31.75c0 5.909-4.675 10.584-10.584 10.584h-31.75c-5.909 0-10.584-4.675-10.584-10.584v-31.75c0-5.909 4.675-10.584 10.584-10.584z", transform: "matrix(.1 0 0 .1 0 0)" }) }))),
        checkedIcon: (jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 6.35 6.35", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { className: "checkbox-box-icon", d: "M15.875 0C7.126 0 0 7.126 0 15.875v31.75C0 56.374 7.126 63.5 15.875 63.5h31.75c8.749 0 15.875-7.126 15.875-15.875v-31.75C63.5 7.126 56.374 0 47.625 0Zm0 5.291h31.75c5.909 0 10.584 4.675 10.584 10.584v31.75c0 5.909-4.675 10.584-10.584 10.584h-31.75c-5.909 0-10.584-4.675-10.584-10.584v-31.75c0-5.909 4.675-10.584 10.584-10.584Z", transform: "scale(.1)" }), jsx("path", { className: "checkbox-check-icon", d: "M28.214 42.357 17.608 31.75l3.535-3.536 7.071 7.072 14.143-14.143 3.535 3.536z", transform: "scale(.1)" })] }))),
    },
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                backgroundClip: 'content-box',
                fill: theme.palette.grey[300],
                '&:not(.Mui-disabled)': {
                    '& .checkbox-check-icon': {
                        fill: theme.palette.primary.main,
                    },
                },
                '&:hover': {
                    backgroundColor: 'transparent',
                    fill: theme.palette.primary.main,
                },
                '&.Mui-disabled': {
                    backgroundColor: theme.palette.grey[100],
                },
                '&.Mui-focusVisible': {
                    fill: theme.palette.primary.main,
                },
            });
        },
    },
};

var MuiDialogTitle = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.primary.main,
            });
        },
    },
};

var MuiInputBase = {
    styleOverrides: {
        input: {
            padding: 0,
        },
        root: {
            padding: '0.75rem 1rem',
        },
    },
};

var MuiOutlinedInput = {
    defaultProps: {
        notched: false,
    },
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                '& .MuiOutlinedInput-notchedOutline': {
                    borderWidth: 1,
                },
                '&.Mui-disabled': {
                    backgroundColor: theme.palette.grey[100],
                    '.MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.grey[300],
                    },
                },
                '&:not(.Mui-disabled)': {
                    '&:not(.Mui-error):not(.MuiInputBase-colorSuccess)': {
                        '&:hover': {
                            '.MuiOutlinedInput-notchedOutline': {
                                borderColor: theme.palette.primary.main,
                            },
                        },
                    },
                },
                '&.Mui-error': {
                    backgroundColor: red[50],
                    color: red[900],
                },
                '&.Mui-focused': {
                    '.MuiOutlinedInput-notchedOutline': {
                        borderWidth: 1,
                    },
                    '&.Mui-error': {
                        '.MuiOutlinedInput-notchedOutline': {
                            borderWidth: 2,
                        },
                    },
                    '&.MuiInputBase-colorSuccess': {
                        '.MuiOutlinedInput-notchedOutline': {
                            borderWidth: 2,
                        },
                    },
                    '&:not(.Mui-error):not(.MuiInputBase-colorSuccess)': {
                        '.MuiOutlinedInput-notchedOutline': {
                            borderColor: theme.palette.primary.main,
                        },
                    },
                },
                '&.MuiInputBase-colorSuccess': {
                    backgroundColor: theme.palette.success.light,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.success.main,
                    },
                },
            });
        },
        input: {
            padding: 0,
        },
    },
};

var MuiTab = {
    styleOverrides: {
        root: {
            textTransform: 'none',
        },
    },
};

var MuiTooltip = {
    defaultProps: {
        arrow: true,
    },
    styleOverrides: {
        arrow: {
            color: 'black',
        },
        tooltip: {
            backgroundColor: 'black',
            borderRadius: '0.625rem',
            fontSize: '0.75rem',
        },
    },
};

var MuiButton = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                border: 'none',
                borderRadius: 0,
                color: theme.palette.primary.main,
                '&.Mui-selected': {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                    },
                },
                '&.Mui-disabled': {
                    border: 'none',
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    color: theme.palette.grey[300],
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: theme.palette.grey[300],
                    },
                },
            });
        },
    },
};

var components = {
    MuiAutocomplete: MuiAutocomplete,
    MuiButton: MuiButton$1,
    MuiButtonBase: MuiButtonBase,
    MuiCheckbox: MuiCheckbox,
    MuiDialogTitle: MuiDialogTitle,
    MuiInputBase: MuiInputBase,
    MuiOutlinedInput: MuiOutlinedInput,
    MuiTab: MuiTab,
    MuiToggleButton: MuiButton,
    MuiTooltip: MuiTooltip,
};

var primaryTheme = createTheme({
    palette: {
        primary: {
            main: '#096da9',
            dark: '#0E5B8B',
            light: '#1E7EB8',
            contrastText: '#FFFFFF',
        },
        success: {
            main: '#74C5A1',
            light: '#EEFBF5',
        },
        grey: {
            300: '#D7DAE2',
        },
    },
    typography: {
        allVariants: {
            fontFamily: 'Open Sans',
        },
        h2: {
            fontSize: '2em',
        },
    },
    components: __assign({}, components),
});

var filterOptions = function (options, filterText) {
    return options.filter(function (option) { return option.value.toLowerCase().includes(filterText.toLowerCase()); });
};
var filterOptionsByChar = function (options, char) {
    return char === '0'
        ? options.filter(function (_a) {
            var value = _a.value;
            return value.match('[_0-9](.*)');
        })
        : options.filter(function (_a) {
            var value = _a.value;
            return value.toLocaleLowerCase().startsWith(char.toLocaleLowerCase());
        });
};

var Multiselect = function (props) {
    var theme = useTheme();
    var loaderItems = props.loadingPlaceHolders || 15; // configuration: number of skeleton loader placeholders
    var _a = useState('Loading'), selectionLabel = _a[0], setSelectionLabel = _a[1];
    var _b = useState(''), headerLabel = _b[0], setHeaderLabel = _b[1];
    var _c = useState(false), selectAll = _c[0], setSelectAll = _c[1];
    var _d = useState(''), filterText = _d[0], setFilterText = _d[1];
    var _f = useState(''), filterChar = _f[0], setFilterChar = _f[1];
    var _g = useState([]), displayedOptions = _g[0], setDisplayedOptions = _g[1];
    var _h = useState(true), selectMode = _h[0], setSelectMode = _h[1];
    var _j = useState([]), selected = _j[0], setSelected = _j[1];
    // updating is set to true when a new page of content is being requested from the data source
    var _k = useState(false), updating = _k[0], setUpdating = _k[1];
    var debouncedSetFilterText = debounce(props.setFilterText, 500);
    var isSelectAllEnabled = function () { return props.options.length > 0 && selectMode && !props.loading; };
    var isSelectionChecked = function () { return selected.length > 0 || selectAll; };
    var isDoneEnabled = function () { return (selectAll || selected.length > 0) && selectMode; };
    var hasMore = useMemo(function () {
        return !props.loading &&
            props.options.length > 0 &&
            displayedOptions.length < tocCountForChar(props.toc, filterChar);
    }, [props.loading, props.options, displayedOptions, props.toc]);
    var showResults = function () { return selectMode && !props.error; };
    var isOptionSelected = function (curOption) {
        return selected.some(function (selOption) { return selOption.optionId === curOption.optionId; }) ||
            selectAll;
    };
    // calculate the column sizing for the results based on the MUI grid width of 12
    // defaults to 3 columns, or xs={4}
    var resultColumns = 12 / (props.columns || 3);
    /**
     * Load the right page of data for the current filter char - but only if that page is not already loaded
     * @param {string} char - the filter char to load page for
     * @param {boolean} forceLoad - force loading of the target page
     * @returns {void}
     */
    var loadPageForFilterChar = function (char, forceLoad) {
        if (forceLoad === void 0) { forceLoad = false; }
        var targetPage = tocPageForChar(props.toc, char);
        // A load is only required when currentPage < targetPage
        // This is because of the way loadMore works - the data for a particular char may be split between 2 pages.
        // As long as the current page is equal to or greater the ToC page, it means the right data is loaded
        // However, this is always overridden if the user has changed the filterChar
        var loadRequired = targetPage >= 0 && props.currentPage < targetPage;
        // when the user is selecting a new filter char, we always need to request that page of data to be loaded
        // the only exception to this is if the requested page is already loaded.
        // this may also occur if there is only a single page of data.
        var shouldForceLoad = forceLoad && props.currentPage !== targetPage;
        if (loadRequired || shouldForceLoad) {
            setUpdating(true);
            props.loadPage(targetPage);
        }
    };
    /**
     * The options displayed by this component are always filtered by the selected alphabetical
     * `filterChar`. Anytime this value changes, the displayed options are updated
     * If the incoming options change, the results are also re-filtered. This will occur when loading
     * a specific page, or loading more - (loading the next page)
     */
    useEffect(function () {
        if (filterChar !== '') {
            var filtered = filterOptionsByChar(props.options, filterChar);
            setDisplayedOptions(__spreadArray(__spreadArray([], displayedOptions, true), filtered, true));
            // if we've reached this point and the filtered set of options has a size of 0,
            // it means we've likely ended up on the incorrect page after the filter text has been changed
            // The ToC useEffect will trigger loading of a new page, so we do not want to clear updating yet.
            if (filtered.length > 0 || props.options.length === 0) {
                setUpdating(false);
            }
        }
    }, [filterChar, props.options]);
    // Whenever we get a Table Of Contents update, update the alphabetical values with no options available.
    // If needed, reset the filter char to the first char with options available
    useEffect(function () {
        if (props.toc) {
            var newFilterChar = tocDoOptionsExistForChar(props.toc, filterChar)
                ? filterChar
                : tocFirstOption(props.toc) || '';
            setFilterChar(newFilterChar || '');
            loadPageForFilterChar(newFilterChar);
        }
    }, [props.toc]);
    // When the filter char or displayed options are updated, set the header label with matching display text
    useEffect(function () {
        if (props.totalOptions === 0) {
            setHeaderLabel('No results found');
        }
        // options exist in the data source, but none match the filter text
        if (props.totalOptions > 0 && props.options.length === 0) {
            setHeaderLabel('No matching results found');
        }
        if (filterChar !== '' && displayedOptions.length > 0 && !updating) {
            setHeaderLabel("".concat(filterChar, " - Showing ").concat(displayedOptions.length, " of ").concat(tocCountForChar(props.toc, filterChar), " options"));
        }
    }, [filterChar, displayedOptions, props.loading]);
    useEffect(function () {
        if (props.totalOptions > 0 && !props.loading) {
            // TODO: we need an i18n library to handle pluralization!
            var label = selected.length === 0
                ? "Select All (".concat(props.totalOptions, ")")
                : "Select ".concat(selected.length, " options");
            setSelectionLabel(label);
        }
    }, [selected, props.totalOptions, props.loading]);
    var onSelect = function (selectedOption, checked) {
        if (checked) {
            setSelected(__spreadArray(__spreadArray([], selected, true), [selectedOption], false));
        }
        else {
            // if selectAll is currently active, any de-selection turns off that mode
            // we cannot currently support using select all to exclude particular items,
            // because not all items will be loaded at once.
            setSelectAll(false);
            var filtered = selected.filter(function (_a) {
                var optionId = _a.optionId;
                return optionId !== selectedOption.optionId;
            });
            setSelected(filtered);
        }
    };
    var filterTextChange = function (event) {
        setSelectMode(true);
        setUpdating(true);
        setDisplayedOptions([]);
        setFilterText(event.target.value);
        debouncedSetFilterText(event.target.value);
    };
    var handleCompleteSelection = function () {
        setFilterText('');
        setSelectMode(false);
        props.onSelect(selected, selectAll);
    };
    var handleFilterCharSelect = function (selectedChar) {
        var newFilterChar = selectedChar[0];
        setDisplayedOptions([]);
        setFilterChar(newFilterChar);
        loadPageForFilterChar(newFilterChar, true);
    };
    var onSelectionChange = function (checked) {
        // no options selected, this means user wants to select all
        if (selected.length === 0 && checked) {
            setSelectAll(true);
        }
        // select all true, disabling
        if (selectAll && !checked) {
            setSelectAll(false);
        }
        // options have been manually selected, unchecking removes them all
        if (selected.length > 0 && !checked) {
            setSelected([]);
        }
    };
    return (jsxs(Fragment, { children: [jsxs(Grid, __assign({ container: true, spacing: 1 }, { children: [jsx(Grid, __assign({ item: true, xs: 6, md: 7 }, { children: jsx(TextField, { autoFocus: true, fullWidth: true, error: props.error, disabled: props.totalOptions === 0, placeholder: props.error ? props.errorLabel : props.searchLabel, InputProps: {
                                endAdornment: (jsxs(Fragment, { children: [jsx(InputAdornment, __assign({ position: "end" }, { children: jsx(SearchIcon, {}) })), jsx(InputAdornment, __assign({ position: "end" }, { children: jsx(IconButton, __assign({ size: "small", onClick: function () { return setSelectMode(!selectMode); } }, { children: selectMode ? jsx(ExpandLess, {}) : jsx(ExpandMore, {}) })) }))] })),
                            }, value: filterText, onChange: filterTextChange }) })), jsx(Grid, __assign({ item: true, xs: 6, md: 5 }, { children: jsxs(Grid, __assign({ container: true, justifyContent: "flex-end", alignItems: "center", spacing: 1 }, { children: [jsx(Grid, __assign({ item: true }, { children: jsx(Checkbox, { checked: isSelectionChecked(), disabled: !isSelectAllEnabled(), label: selectionLabel, onChange: function (_e, checked) {
                                            onSelectionChange(checked);
                                        } }) })), jsx(Grid, __assign({ item: true }, { children: jsx(Button, __assign({ variant: "contained", disabled: !isDoneEnabled(), onClick: handleCompleteSelection }, { children: "Done" })) }))] })) }))] })), jsx(Collapse, __assign({ in: showResults() }, { children: jsxs(Grid, __assign({ container: true, spacing: 1, sx: { marginTop: '0.5em' } }, { children: [jsx(Grid, __assign({ item: true, xs: 12 }, { children: jsx(AlphaSelector, { isExclusive: true, selectedOptions: [filterChar], toc: props.toc ? props.toc : { data: [] }, label: props.alphaSelectorLabel, onChange: handleFilterCharSelect }) })), jsx(Grid, __assign({ item: true, xs: 12 }, { children: props.loading || updating ? (jsx(Skeleton, { variant: "rectangular", height: '2.5em' })) : (jsx(Paper, __assign({ elevation: 0, square: true, variant: "outlined", sx: {
                                    backgroundColor: theme.palette.grey[200],
                                    padding: '0.5em',
                                } }, { children: jsx(Typography$1, { children: headerLabel }) }))) })), (props.loading || updating) && displayedOptions.length === 0
                            ? Array.from(Array(loaderItems)).map(function (_option, index) { return (jsx(Grid, __assign({ item: true, xs: resultColumns }, { children: jsx(Skeleton, __assign({ variant: "rounded", width: '100%' }, { children: jsx(Checkbox, {}) })) }), index)); })
                            : displayedOptions.map(function (option) { return (jsx(Grid, __assign({ item: true, xs: resultColumns }, { children: jsx(Checkbox, { "data-testid": "option-checkbox", variant: "tooltip", checked: isOptionSelected(option), label: option.value, onChange: function (_e, checked) {
                                        onSelect(option, checked);
                                    } }) }), option.optionId)); }), jsx(Grid, __assign({ item: true, xs: 12 }, { children: props.loading || updating ? (jsx(Skeleton, { variant: "rounded", height: '2.5em' })) : (jsx(Button, __assign({ variant: "outlined", disabled: !hasMore, fullWidth: true, onClick: props.loadMore }, { children: "Load More" }))) }))] })) }))] }));
};

var ExclamationErrorIcon = createSvgIcon(jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg" }, { children: jsxs("g", __assign({ transform: "translate(47 47)" }, { children: [jsx("path", { fill: "rgba(0, 0, 0, 0.175)", d: "M160,0A160,160,0,1,1,0,160,160,160,0,0,1,160,0Z", transform: "translate(-47 -47)" }), jsx("path", { fill: "currentColor", d: "M84,120h18v18H84Zm0-72h18v54H84ZM92.91,3A90,90,0,1,0,183,93,89.956,89.956,0,0,0,92.91,3ZM93,165a72,72,0,1,1,72-72A71.98,71.98,0,0,1,93,165Z", transform: "translate(20 20)" })] })) })), 'ExclamationError');

var UnauthorizedErrorIcon = createSvgIcon(jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 320" }, { children: jsxs("g", __assign({ transform: "translate(47 47)" }, { children: [jsx("path", { fill: "rgba(0, 0, 0, 0.175)", d: "M160,0A160,160,0,1,1,0,160,160,160,0,0,1,160,0Z", transform: "translate(-47 -47)" }), jsx("path", { fill: "currentColor", d: "M71,131.5a16.25,16.25,0,1,0-16.25-16.25A16.3,16.3,0,0,0,71,131.5Zm48.75-73.125h-8.125V42.125a40.625,40.625,0,1,0-81.25,0v16.25H22.25A16.3,16.3,0,0,0,6,74.625v81.25a16.3,16.3,0,0,0,16.25,16.25h97.5A16.3,16.3,0,0,0,136,155.875V74.625A16.3,16.3,0,0,0,119.75,58.375ZM45.813,42.125a25.188,25.188,0,0,1,50.375,0v16.25H45.813Zm73.938,113.75H22.25V74.625h97.5Z", transform: "translate(42.308 26.467)" })] })) })), 'UnauthorizedError');

var UnsupportedBrowserErrorIcon = createSvgIcon(jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg" }, { children: jsxs("g", { children: [jsx("path", { fill: "rgba(0, 0, 0, 0.175)", d: "M160,0A160,160,0,1,1,0,160,160,160,0,0,1,160,0Z" }), jsx("path", { fill: "currentColor", d: "M15.5,247.671A15.475,15.475,0,0,1,.022,232.2V15.539A15.475,15.475,0,0,1,10.544.063h.31a15.214,15.214,0,0,1,1.857,0,15.491,15.491,0,0,1,2.786,0H232.154A15.475,15.475,0,0,1,247.63,15.539V232.2a15.475,15.475,0,0,1-15.476,15.475ZM30.973,216.72H216.679V92.916H30.973Zm61.9-170.23A15.325,15.325,0,0,0,108.35,61.965H201.2a15.476,15.476,0,0,0,0-30.951H108.35A15.325,15.325,0,0,0,92.875,46.49Zm-61.9,0A15.476,15.476,0,1,0,46.448,31.014,15.325,15.325,0,0,0,30.973,46.49ZM143.138,184.651l-19.323-19.323-19.323,19.323a6.073,6.073,0,0,1-8.589,0l-4.295-4.294a6.075,6.075,0,0,1,0-8.589l19.323-19.323L91.608,133.123a6.076,6.076,0,0,1,0-8.59l4.295-4.294a6.073,6.073,0,0,1,8.589,0l19.323,19.323,19.323-19.323a6.073,6.073,0,0,1,8.589,0l4.295,4.294a6.076,6.076,0,0,1,0,8.59L136.7,152.446l19.323,19.323a6.075,6.075,0,0,1,0,8.589l-4.295,4.294a6.073,6.073,0,0,1-8.589,0Z", transform: "translate(74 74), scale(0.7)" })] }) })), 'UnsupportedBrowserError');

function getIcon(iconType) {
    if (iconType === void 0) { iconType = 'exclamation'; }
    switch (iconType) {
        case 'exclamation':
        default:
            return ExclamationErrorIcon;
        case 'unsupported-browser':
            return UnsupportedBrowserErrorIcon;
        case 'unauthorized':
            return UnauthorizedErrorIcon;
    }
}
function AppError(props) {
    var actionsProp = props.actions, children = props.children, iconType = props.iconType, iconProps = props.iconProps, message = props.message, messageProps = props.messageProps, title = props.title, titleProps = props.titleProps, showBackButton = props.showBackButton, showRetryButton = props.showRetryButton, rest = __rest(props, ["actions", "children", "iconType", "iconProps", "message", "messageProps", "title", "titleProps", "showBackButton", "showRetryButton"]);
    var Icon = getIcon(iconType);
    var history = useHistory();
    var builtInActions = [];
    if (showBackButton && history.length > 1) {
        builtInActions.push({
            children: 'Go Back',
            onClick: function () { return history.goBack(); },
            autoFocus: true,
        });
    }
    if (showRetryButton) {
        builtInActions.push({
            children: 'Retry',
            onClick: function () { return window.location.reload(); },
            autoFocus: true,
        });
    }
    var actions = actionsProp ? __spreadArray(__spreadArray([], builtInActions, true), actionsProp, true) : builtInActions;
    return (jsx(Box, __assign({}, rest, { sx: __assign({ position: 'fixed', inset: 0, flex: '1 0 auto', padding: '80px 6vw 40px', backgroundColor: 'primary.main', color: 'primary.contrastText', overflowY: 'auto', 
            /**
             * Temporarily set Link component focus outline to have appropriate contrast
             * against the dark background.
             * This (along with other temporary styles) should be removed once the
             * design system has been updated to include these styles.
             */
            '.MuiLink-root:focus-visible': { outline: '1px solid currentColor' } }, rest === null || rest === void 0 ? void 0 : rest.sx) }, { children: jsxs(Box, __assign({ sx: {
                display: 'grid',
                flex: '1 0 auto',
                gridTemplateColumns: 'auto minmax(200px, 430px)',
                gridGap: '60px',
                alignItems: 'center',
                minHeight: '70%',
                maxWidth: '1200px',
                margin: 'auto',
            } }, { children: [jsxs("div", { children: [jsx(Typography$1, __assign({ variant: "h1", sx: { fontSize: '60px', fontWeight: '600', marginBottom: 1.5 } }, titleProps, { children: title })), jsx(Typography$1, __assign({ sx: { fontSize: '26px', fontWeight: 'light' } }, messageProps, { children: message })), children && jsx(Box, __assign({ sx: { marginTop: 1.5, marginBottom: 3.5 } }, { children: children })), actions && (jsx(Box, __assign({ sx: { marginY: 3, display: 'flex', gap: 1 } }, { children: actions.map(function (_a, index) {
                                _a.renderCondition; var buttonProps = __rest(_a, ["renderCondition"]);
                                return (jsx(Button, __assign({ color: "inherit", variant: "outlined", size: "large" }, buttonProps), index));
                            }) }))), jsxs(Typography$1, __assign({ sx: { marginTop: 3 } }, { children: ["If this problem persists, please contact our\u00A0", jsx(Link, __assign({ href: "mailto:elevatesupport@service.riversideinsights.com", color: "inherit" }, { children: "Riverside Insights Technical Support Team" })), "."] }))] }), jsx(Icon, __assign({ viewBox: "0 0 320 320" }, iconProps, { sx: __assign({ width: '100%', height: '100%', color: (iconProps === null || iconProps === void 0 ? void 0 : iconProps.color) ? undefined : 'rgba(0, 0, 0, 0.3)' }, iconProps === null || iconProps === void 0 ? void 0 : iconProps.sx) }))] })) })));
}

export { AlphaSelector, AppError, AppLoader, Autocomplete, Button, Checkbox, Multiselect, filterOptions as MultiselectFilterOptions, TextField, Tooltip, primaryTheme };
